<div class="aside has-header has-footer has-margin-icon">

    <div class="aside-header">
        <div class="row">
            <div class="col-auto">
                <i class="header-icon icon-add"></i>
            </div>
            <div class="col">
                <div class="title title-bg">
                    <div class="title-details">
                        <span class="title-details-name">{{ 'name' }}</span>
                        <span class="title-details-label">{{ 'detail' }}</span>
                    </div>
                    <h2 class="title-main">{{ 'title'}}</h2>
                </div>
            </div>
        </div>
    </div>

    <div class="aside-content">
        <div class="aside-content-body">
            <div class="section">
                <div class="section-header">
                    <h3 class="header-content">header title</h3>
                </div>
                <div class="section-content">
                    <div class="separator"></div>
                    <div class="row">
                        <div class="col-12">
                            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusantium blanditiis, ea esse
                                molestias mollitia obcaecati reiciendis. Aliquid at dignissimos doloribus facere impedit
                                inventore nesciunt nisi, nostrum quod ratione sint voluptas.</p>

                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>

    <div class="aside-footer">
        <div class="footer-btn-left">
            <button (click)="close()" class="btn btn-secondary" type="button">{{ 'LABEL.BACK' | translate }}</button>
        </div>
        <div class="footer-btn">
            <button (click)="close()" class="btn btn-secondary" type="button">{{ 'LABEL.CLOSE' | translate }}</button>
            <button (click)="close()" class="btn btn-primary" type="button">{{ 'LABEL.SAVE' | translate }}</button>
        </div>
    </div>

</div>
